import isArchived from 'archive/isArchived';

import {MaybeArchivableItem} from './ArchiveConstants';

export default function getArchiveAwareDisplayName(item: MaybeArchivableItem): string {
  return `${item.name}${isArchived(item) ? ' (archived)' : ''}`;
}
